import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public estaLogueado: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() { }

  obtenerSesionUsuario() : any {
    return JSON.parse(localStorage.getItem('session_app'));
  }

  crearSesion(usuario: any){
    let session = {
      sessionId: usuario.id,
      code_ter: usuario.idTercero,
      token: usuario.token,
      rol: usuario.rol,
      nombre_session: usuario.nombreCompleto
    };
    
    localStorage.setItem('session_app', JSON.stringify(session));
  }

  cerrarSesion(){
    localStorage.removeItem('session_app');
  }

}
